import * as Constants from '@/lib/constants'
export const YES = true.toString()
export const NO = false.toString()
export const GEOJSON_PROPERTY_FIELD_ENABLED = 'AID_GEOJSON_PROPERTY_FIELD_ENABLED'
export const GEOJSON_PROPERTY_FIELD_ID = 'AID_GEOJSON_PROPERTY_FIELD_ID'
export const FIELD_FILL_COLOR = Constants.FIELD_FILL_COLOR
export const FIELD_FILL_OPACITY = Constants.FIELD_FILL_OPACITY
export const FIELD_DISABLED_FILL_COLOR = '#B1CCCB'

const GEOJSON_PROPERTIES = [GEOJSON_PROPERTY_FIELD_ENABLED, GEOJSON_PROPERTY_FIELD_ID]
const OGR2OGR_PROPERTIES = ['tessellate', 'extrude', 'visibility']
const GEOJSON_IGNOREABLE_PROPERTIES = GEOJSON_PROPERTIES.concat(OGR2OGR_PROPERTIES)

export function canIgnoreGeoJsonProperty(propName) {
  for (let i = 0; i < GEOJSON_IGNOREABLE_PROPERTIES.length; i++) {
    if (GEOJSON_IGNOREABLE_PROPERTIES[i] === propName) {
      return true
    }
  }
  return false
}
